import * as React from 'react';
import Dropzone from 'react-dropzone';

interface BatchDropZoneProps {
    onDrop: (file: Blob) => void,
    fileName: string
}

class BatchDropZone extends React.Component <BatchDropZoneProps, {}> {
    public onDrop(file: Blob) {
        this.props.onDrop(file);
    }

    public render() {
        return (
            <div className="cmInput">
                <Dropzone className="batchDropZoneContainer" accept=".csv" multiple={false} onDrop={this.onDrop.bind(this)}>
                    <div className="cmVerCenter batchDropZoneFileName">{this.props.fileName}</div>
                </Dropzone>
            </div>
        );
    }
}

export default BatchDropZone;



// WEBPACK FOOTER //
// ./src/Components/Batch/BatchDropZone.tsx